export default "__VITE_ASSET__4sYijz10__"